import "./ProjectDetail.css"
import html from "./ProjectDetail.html"
import "../../Survey/SurveyCompletion/ConsentSurveyContainer.js"
import "../../Survey/SurveyCompletion/SurveyTemplateContainer.js"
import moment from 'moment-timezone';

var module = angular.module("ResearchKitApplicationModule");

module.component('projectDetail', {
	template: html,
	bindings: {
		"code": "<",
		"join": "<"
	},
	controller: 'projectDetailController',
	controllerAs: 'vm'
});

module.controller("projectDetailController", ["$scope", "$http", "ceUrl", "$timeout",
	function ($scope, $http, ceUrl, $timeout) {
		var vm = this;

		vm.$onInit = function () {
			loadProject();
		}

		var identifierValidationSurvey = {
			"type": "RKStudioNavigableOrderedTask",
			"name": "Survey",
			"identifier": "Survey",
			"steps": [
				{
					"type": "QuestionStep",
					"text": "Please enter your participant identifier in order to enroll.",
					"title": "Identifier Check",
					"identifier": "ParticipantIdentifier",
					"answerFormat": {
						"type": "TextAnswerFormat",
						"multipleLines": false,
						"keyboardType": "Text"
					},
					"optional": false,
					"placeholder": "Identifier"
				}
			]
		};
		var invalidIdentifierValidationSurvey = angular.copy(identifierValidationSurvey);
		invalidIdentifierValidationSurvey.steps[0].text = "Invalid identifier.  Please enter your participant identifier in order to enroll.";

		vm.getBrandingImageUrl = function () {
			if (!vm.project) { return; }
			// Aug-23-2021: String interpolation here breaks minifier/bundler.
			return "url('" + ceUrl.make("api/researchkit/organizationbrandingimage/" + vm.project.OrganizationID) + "')";
		}

		vm.consentDocumentUrl = function (document) {
			return ceUrl.make("api/researchkit/studyparticipant/document/" + document.ID);
		}

		vm.joinProject = function () {
			if (vm.project.RequiresIdentifierValidation) {
				vm.identifierValidationSurvey = identifierValidationSurvey;
			} else {
				startConsent();
			}
		}

		var startConsent = function () {
			vm.identifierValidationSurvey = null;
			$timeout(function () {
				vm.enrollingProjectId = vm.project.ID;
			})
		}

		vm.declineInvitation = function () {
			if (window.confirm("Are you sure you want to decline?")) {
				vm.loading = true;
				$http.post(ceUrl.make("api/researchkit/studyenrollment/invitations/" + vm.project.InvitationID + "/decline")).then(function () {
					window.history.back();
					$scope.$emit("refreshParticipantInfo");
				});
			}
		}

		$scope.$on('surveyFinished', function (event, reason, taskResult, completionAction) {
			event.stopPropagation();
			if (taskResult) {
				if (vm.project.RequiresIdentifierValidation && !vm.enrollingIdentifier) {
					var identifier = taskResult.StepResults[0].QuestionResults[0].Answers[0];
					$http.post(ceUrl.make("api/researchkit/studyenrollment/studies/" + vm.project.ID + '/validateidentifier'), '"' + identifier + '"')
						.then(function () {
							vm.enrollingIdentifier = identifier;
							startConsent();
						})
						.catch(function () {
							vm.identifierValidationSurvey = null;
							$timeout(function () {
								vm.identifierValidationSurvey = invalidIdentifierValidationSurvey;
							})
						});
					return;
				}
				vm.loading = true;

				loadProject();
				$scope.$emit("refreshParticipantInfo", vm.project.ID);
				if (completionAction) {
					completionAction.patientID = result.data.ParticipantID;
					$scope.$emit("performAction", completionAction);
				}
			}
			vm.enrollingIdentifier = null;
			vm.enrollingProjectId = null;
			vm.identifierValidationSurvey = null;
		});

		vm.sendMessage = function () {
			$scope.$emit("NavigateToView", { type: "Conversation", code: vm.project.StudyCode });
		}

		function loadProject() {
			vm.loading = true;
			var url = "api/researchkit/studyenrollment/studies/" + vm.code + "?offset=" + encodeURIComponent(moment().format("Z"));
			$http.get(ceUrl.make(url)).then(function (response) {
				vm.project = response.data;
				if (vm.join) {
					if (vm.project.Enrolled) {
						$scope.$emit("refreshParticipantInfo", vm.project.ID);
					} else {
						vm.joinProject();
					}
				}
			}).finally(function () {
				vm.loading = false;
			});
		}
	}
]);